import AppLayout from "containers/AppLayout/AppLayout";

export default () => (
  <div className="h-full flex flex-1 justify-center items-center flex-col">
    <img src="/Logo-Transparent.png" width={150} className="mb-6"/>
    <h1>Page not found</h1>
    <h4>Please check the link</h4>
  </div>
);
